export function attachRevealSessionRevalidation(
  revealView: any,
  refreshSession: () => Promise<boolean>,
): void {
  const runCheck = () => {
    void refreshSession();
  };

  const existingDataPoint = revealView.onVisualizationDataPointClicked;
  revealView.onVisualizationDataPointClicked = function (visualization: any, cell: any, row: any) {
    runCheck();
    if (typeof existingDataPoint === 'function')
      existingDataPoint.call(revealView, visualization, cell, row);
  };

  const existingDashboardChanged = revealView.onDashboardChanged;
  revealView.onDashboardChanged = function (...args: unknown[]) {
    runCheck();
    if (typeof existingDashboardChanged === 'function')
      existingDashboardChanged.apply(revealView, args);
  };
}
